import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserAccessService {
  private roles: any[] = [];

  setRoles(roles: any[]) {
    this.roles = roles || [];
  }

  clear() {
    this.roles = [];
  }

  isAllowed(sectionName: string): boolean {
    if (!sectionName) return true;
    return this.roles.some(role =>
      role.permissionSections?.some(
        (s: any) => s.sectionName?.toLowerCase() === sectionName.toLowerCase() && s.enabled === true
      )
    );
  }
}